import { ref } from 'vue'
import { isBoolean, isNumber } from 'lodash'

export function useToggle(val = false) {
  const value = ref(val)
  /**
   * 切换显示状态
   * @param {boolean | number} [val]
   * @param {number} [delay]
   */
  function toggle(...args) {
    let val = !value.value
    const fn = () => (value.value = val)
    if (!args.length) fn()
    else {
      let delay
      if (args.length === 1) {
        if (isNumber(args[0])) delay = args[0]
        else if (isBoolean(args[0])) val = args[0]
      } else [val, delay] = args
      if (delay) setTimeout(fn, delay)
      else fn()
    }
  }

  return { value, toggle }
}
